import * as React from 'react';
import clsx from 'clsx';
import { ComponentPropsWithoutRef } from 'react';
import { IGIInputProps } from './GIInput';
import { LABEL_ID_SUFFIX } from '@constants/individualPortal/customGrouping/customGrouping.constants';

type GIFormLabelPropsPicked = 'className' | 'children' | 'aria-label' | 'onChange';

interface IGIFormLabelProps extends Pick<ComponentPropsWithoutRef<'label'>, GIFormLabelPropsPicked>, Pick<IGIInputProps, 'name' | 'required' | 'type'> {
  id: string;
  /** Custom label ID. Defaults to `${id}-label` to avoid duplicate IDs with associated form controls */
  labelId?: string;
  hideLabel?: boolean;
}

export const GIFormLabel = ({
    id,
    className,
    children,
    name,
    required,
    type = 'text',
    'aria-label': ariaLabel,
    onChange,
    labelId: customLabelId,
    hideLabel = false,
}: IGIFormLabelProps) => {
    const computedClassNames = {
        checkbox: 'usa-checkbox__label gi-checkbox__label',
        text: 'gi-input__label'
    };
    const labelClassName = computedClassNames[type] || 'gi-input__label';
    // Use '-label' suffix to avoid duplicate IDs when used with form controls
    const labelId = customLabelId || `${id}${LABEL_ID_SUFFIX}`;

    return (
        <label
            id={labelId}
            data-automation-id={id}
            data-testid={id}
            htmlFor={name}
            aria-label={ariaLabel}
            className={clsx(labelClassName, className, `required-${required}`)}
            onClick={onChange}
        >
            {hideLabel ? <span className="sr-only">{children}</span> : children}
        </label>
    );
};